import { useState, useEffect } from "react";
import API from "../api/axios";

export default function usePlan() {
  const [plan, setPlan] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    API.get("/user/plan")
      .then((res) => {
        if (!mounted) return;
        const data = res.data || {};
        const expiresAt = data.expires_at ? new Date(data.expires_at) : null;
        const now = new Date();
        const days_left = expiresAt ? Math.max(0, Math.ceil((expiresAt - now) / (1000 * 60 * 60 * 24))) : null;

        // Override status if days_left is 0 or less
        let status = data.status;
        if (status === "subscribed" && (days_left === 0 || days_left < 0)) {
          status = "expired";
        }

        setPlan({ ...data, days_left, status });
      })
      .catch(() => {
        if (!mounted) return;
        setPlan({ status: "trial", plan: "free", days_left: 14 });
      })
      .finally(() => mounted && setLoading(false));

    return () => {
      mounted = false;
    };
  }, []);

  const isPaid = plan?.status === "subscribed";
  const isTrial = plan?.status === "trial";
  const isExpired = plan?.status === "expired";

  const isStarter = plan?.plan === "starter" && isPaid;
  const isBasic = plan?.plan === "basic" && isPaid;
  const isPro = plan?.plan === "pro" && isPaid;

  const hasFullAccess = Boolean(isPaid || isPro || isBasic || isStarter || isTrial);

  const getProductLimit = () => {
    if (isExpired) return 10;
    if (isStarter) return 30;
    if (isBasic) return 500;
    if (isPro) return Infinity;
    if (isTrial) return Infinity;
    return 10;
  };

  return {
    plan,
    loading,
    isPaid,
    isTrial,
    isExpired,
    isStarter,
    isBasic,
    isPro,
    hasFullAccess,
    getProductLimit,
  };
}

